import { inject } from '@angular/core';
import { CommonService } from '../services/common/common.service';
import { firstValueFrom, Observable } from 'rxjs';
import { CoreService } from '../services/core/core.service';
import { UserSelectionService } from '../services/user-selection/user-selection.service';

export const userDataResolver = (): any => {
  const commonService = inject(CommonService);
  const userSelectionService = inject(UserSelectionService)
  const coreService = inject(CoreService);

  return new Observable((observer) => {
    commonService.userProfileData.subscribe(async(userData) => {
      if(userData) {
        const hasMultiBranchAccess = userData.data.roleDetail.some(x => x.hasMultiBranchAccess);
        const selectedOrg = userSelectionService.getSelectedOrg();
        const orgList = await firstValueFrom(coreService.getAllowedOrganizationList());
        if(hasMultiBranchAccess && orgList?.data?.length > 0) {
          userSelectionService.orgAccessList = orgList.data;
          userSelectionService.multiBranchAccess= true;
          if(!selectedOrg) {
            commonService.dismissBootstrapLoader();
            const dialogRef = userSelectionService.openOrganizationSelectionDialog();
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                observer.next(true);
              }
              observer.complete();
            });
          } else {
            userData.data.userPermission.orgPackages = selectedOrg.orgPackages;
            observer.next(true);
            observer.complete();
          }
        } else {
          userSelectionService.multiBranchAccess= false;
          localStorage.removeItem('selectedOrg');
          observer.next(true);
          observer.complete();
        }
      } else {
        userSelectionService.multiBranchAccess= false;
        localStorage.removeItem('selectedOrg');
        observer.next(true);
        observer.complete();
      }
    })
  });
};